import { ShippingAddressUpdateError } from '../errors';

export const isShippingAddressUpdateError = (error: unknown): error is ShippingAddressUpdateError => {
    return error instanceof ShippingAddressUpdateError;
};
